import type { AlfaAuthConfig } from './socialNetworkUtils';

export const createAlfaAuthUrl = (
  config: AlfaAuthConfig,
  validationState: string,
  isSeamlessAuthorization = false,
) => {
  const redirectTo = new URLSearchParams(window.location.search).get(
    'redirect_to',
  );
  let redirectUri = window.location.origin;

  if (isSeamlessAuthorization) {
    if (redirectTo) {
      redirectUri += `?redirect_to=${redirectTo}`;
    }
  } else {
    redirectUri += '/login/alfabank';
  }

  const params = [
    'response_type=code',
    `client_id=${config.client_id}`,
    `redirect_uri=${encodeURIComponent(redirectUri)}`,
    `scope=${config.scope}`,
    `state=${validationState}`,
  ].join('&');

  return `${
    config.authorize_code_host || 'https://id.alfabank.ru'
  }/oidc/authorize?${params}`;
};
